<h2>Create Product</h2>
<div class="row">
  <div class="col-md-12">
    <form [formGroup] = "imageForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <input type="text" formControlName="productName" class="form-control" placeholder="Product Name">
      </div>
      <div class="form-group">
          <input type="text" formControlName="sku" class="form-control" placeholder="SKU">
        </div>
      <div class="form-group">
        <input type="text" formControlName="price" class="form-control" placeholder="Price">
      </div>
      <div *ngIf="uploadError">
        <div [innerHTML]="uploadError" class="error"></div>
      </div>
      <div class="form-group">
        <div class="upload-image">
          <div #image class="image-wrapper"></div>
          <div class="browse-btn">
            <!-- <input type="file" name="cameraImg" id="cameraImg" (change)="onSelectedFile($event)" /> -->
            <input type="file" accept="image/*"  name="cameraImg" id="cameraImg" (change)="setEvent($event)" ng2FileSelect [uploader]="uploader" />
            <div class="browse-image">
              <img src="assets/images/camera.png" width="60px" />
              <p>Browse image</p>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
      <div class="form-group">
        <button type="submit" class="btn btn-success">Save Product</button>
      </div>
    </form>
      <p>{{ error }}</p>
  </div>
</div>